import CareerPage from '../pages/Career'
import IntroducePage from '../pages/Introduce'
import TechPage from '../pages/Tech'
import portfolioPage from '../pages/Portfolio'


export const Sidebar = {
  profile: 'https://avatars3.githubusercontent.com/u/59439454?s=460&v=4',
  name: '이준영',
  description: '웹 프론트엔드 프로그래머',
  contents: [
    {
      title: '소개',
      path: '/',
      component: IntroducePage
    },
    {
      title: '경력',
      path: '/career',
      component: CareerPage
    },
    {
      title: '기술',
      path: '/tech',
      component: TechPage
    },
    {
      title: '포트폴리오',
      path: '/portfolio',
      component: portfolioPage
    }
  ]
}
export const Tech = {
  title: '기술',
  contents: [
   {
    title: "HTML / CSS",
    contents: [
      {
        subTitle: "HTML 구조를 빠르게 이해하며 코드 작성을 할 수 있습니다.",
        subContents: ["> Semantic을 준수하며, HTML 구조를 미리 구상하며 의미부여를 합니다."]
      },
      {
        subTitle: "flex 사용 위주의 반응형 웹을 잘 다룰 수 있습니다.",
        subContents: ["> PC, 태블릿PC, 스마트 폰 등 다양한 화면 크기에 맞춰 크로스 브라우징을 하도록 구현할 수 있습니다."]
      }
    ]
  },
  {
    title: "JavaScript",
    contents: [
      {
        subTitle: "모던 JavaScript 문법",
        subContents: ["> prototype, arrow function, map, filter, reduce, 동기적 통신(async, await)"]
      }
    ]
  },
  {
    title: "React",
    contents: [
      {
        subTitle: "SPA 사용 경험",
        subContents: ["> props, state, hooks, route, link 문법 사용, 비동기 통신 이해를 수월하게 할 수 있습니다."]
      }
    ]
  },
  { title: "",
    contents: [
      {
        subTitle: 'react와 vue 중 react를 선택한 이유?',
        subContents: ['- stack overFlow 에서 통계를 냈는데, react의 사용자가 뷰에 비해 2배 가량 더 많았으며,',
            '그래서 사용자가 그만큼 많으니 레퍼런스가 많고 일자리의 수요가 더 높습니다'
        ]
      }
    ]
  }
]}

export const Career = {
    title: '경력',
    contents: [
      {
        title: '(주)MSTC',
        contents: [
          {
            subTitle: '현대 Mobis AVN검증 협력회사',
            subContents: ['AVN검증팀에서 내수 정업 / 별도 파트를 담당  > 1년 3개월',
            '전자공학을 전공을 하며 마지막 학년에 교수님 추천으로 Mobis 연구소 AVN팀 협력 회사에서 검증팀 인턴으로 근무하며 회사 생활에 열심히 임하며,',
            '여러 검증 방법을 익히며 인정을 받고 정규직 전환 권유를 받아, 인적성과 면접에서 통과하여 정규직으로 일을 하게 되었습니다.', 
            'D-AUDIO, AVN 사양을 기반으로 주로 양산 차종 AVN (AudioVideoNavigation)에 CANOE Simulator를 통한 전반적인 센서, 제어, 문제점 재현 검증 실시.',
            '내수 정기 업데이트 및 별도 위주로 이슈 발견 및 처리였으며, JIRA(이슈트래커)를 통하여 Mobis와 협력 업무를 하였습니다.,'
            ]
          }
        ]
      },
      {
        contents: [
          {
            subTitle: '검증 실시 내역',
            subContents: ['양산 차종 D-AUDIO 차종 기초 AVN 사양 검증',
            '후방 카메라 및 Early cam 항목 검증',
            '표준형 5세대 내수 1차 정업(나머지 24차종 포함)',
            'TestCase- Android Auto, Carplay, MirrorLink, Bluetooth, Common, Voicememo, System, TMU(Modem), Voice recognition, Interlocking navi,',
            'Eco-friendly, Carlife(중국), Baidu apps(중동)',
            'CANOE Simulator 및 SVM/AVM 장비 사용',
            'Function generator 장비 사용(스피드 측정)',
            '하이브리드(phev,hev), 전기차(ev)',
            '미국, 캐나다, 내수, 유럽, 중국, 중동, 브라질 등 다수 국가 차종 검증']
          }
        ]
      }
    ]
}

export const Interest = {
  title: '소개',
  contents: [
    {
      title: '웹 프론트엔드 개발을 꿈꾸는 이준영입니다.',
      contents: [
        {
        subTitle: '',
        subContents: [
            '첫 회사에서 인턴으로 QA 업무를 진행하다가 우연한 계기에 C언어를 마주했는데 프로그래밍의 매력을 느껴 전향을 결심하게 되었습니다.',
            '회사에서 업무 능력을 인정받아 정규직 제의를 받아 QA 업무와 동시에 프로그래밍 공부를 병행 했습니다. ',
            '프로그래밍 공부를 지속하던 중 웹 프론트엔드 분야를 알게되었습니다.']
        }
      ]
    },
    {
      contents: [
        {
          subTitle: '웹 개발의 흥미를 느낀 계기',
          subContents: [
            '1. html과 css를 다뤄서 직접 사용자가 사용 할 수 있는 동적인 웹을 만들수 있습니다',
            '2. 웹 프론트엔드 분야는 결과물을 즉시 확인할 수 있고, 만들어진 결과물을 배포하여 친구들과 공유할 수 있어서 재미가 있었습니다.',
            '3. frontend 개발자는 꾸준한 공부를 해야 하기 때문에 발전적 삶을 지향하는 나의 가치관과 매우 비슷해 흥미를 느꼈습니다'
          ]
        }
      ]
    },
    {
      contents: [
        {
          subTitle: '웹 개발의 확신하게 된 계기',
          subContents: [
            '1. 폭 넓은 플랫폼 지원에 대한 잠재력',
            '2. 웹 시장의 전망 (미국 2020 유망 직업 1위 - 만족도, 연봉 등)에 대한 확신했습니다',
          ]
        }
      ]
    }
  ]
}

export const Portfolio = {
  title: '포트폴리오',
  contents: [
    {
      title: '',
      contents: [
        {
          subTitle: '',
          subContents: ['',
          ]
        }
      ]
    }
  ]
}
